import React from "react";
import { Form } from "formik";

import UploadField from "../../../UploadField";
import i18n from "../../../../constants/i18n";

const VideoUploadModalView = ({
    hideModal,
    isEditing,
    isSubmitting,
    isVisible,
    setFieldValue,
    status,
    submitForm,
    supportedFormats,
    values
}) => {
    return (
        <div
            className={`modal upload-modal ${
                isSubmitting ? "is-uploading" : ""
            } ${isVisible ? "is-active" : ""}`}
        >
            <div className="modal-background" />
            <div className="modal-card">
                <header className="modal-card-head">
                    <h2 className="modal-card-title has-text-primary">
                        {i18n.videoUploadModal.title}
                    </h2>
                    <button
                        onClick={hideModal}
                        className="delete"
                        aria-label="close"
                    />
                </header>
                <section className="modal-card-body">
                    <Form>
                        <UploadField
                            label={i18n.videoUploadModal.uploadFieldLabel}
                            name="video"
                            setFieldValue={setFieldValue}
                            value={values.video}
                            fileTypes={supportedFormats}
                        />
                    </Form>
                </section>
                <footer className="modal-card-foot">
                    <button
                        onClick={submitForm}
                        disabled={
                            isSubmitting ||
                            (isEditing && !values.video) ||
                            (isEditing &&
                                values.video instanceof File === false)
                        }
                        className="button is-primary is-rounded"
                    >
                        {i18n.generic.save}
                    </button>
                    <div className="progress">
                        <span
                            className="progress-bar"
                            style={{
                                width: `${(status && status.uploadProgress) ||
                                    0}%`
                            }}
                        ></span>
                    </div>
                    <div className="upload-loader-container">
                        <div className="loader upload-loader"></div>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default VideoUploadModalView;
